import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'app/providers/api.service';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { environment } from 'environments/environment';
import { map, switchMap, take, tap, catchError } from 'rxjs/operators';

export interface TaskMetadata {
  departments: { dprt_id: Number; dprt_nm: string; dprt_cd: string; }[];
  priorities: { prty_id: Number; prty_nm: string; clr_tx: string; }[];
  categories: { ctgry_id: Number; ctgry_nm: string; }[];
  statuses: { sts_id: Number; sts_nm: string; clr_tx: string; }[];
  users: { usr_id: Number; usr_nm: string; dsgn_nm?: string; }[];
  designations: { dsgn_id: Number; dsgn_nm: string; }[]
}

@Injectable({
  providedIn: 'root'
})
export class TaskManagerService {
  private _baseURL: string = environment.apiOrigin + '/apiv1/';
  private metadata: TaskMetadata = {
    departments: [],
    priorities: [],
    categories: [],
    statuses: [],
    users: [],
    designations: []
  };

  constructor(private apisrvc: ApiService, private _httpClient: HttpClient, private _snackBar: MatSnackBar,) { }

  getFollowUpTeam() {
    return this.apisrvc.get('task-manager/follow-up-users');
  }

  getTasks(data) {
    // return of(this.tasks);
    const rte = 'task-manager/file/tickets';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }

  getAssgnedTasks(data) {

    const rte = 'task-manager/assigned/file/tickets';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }

  getTaskActivities(data) {

    const rte = 'task-manager/activities/file/tickets';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }
  getallTasks() {
    let data = {}
    const rte = 'task-manager/all/tickets';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {
        resolve(res['data'])
      })
    })

  }

  getMetadata() {
    const rte = 'task-manager/master-data';
    //  new Promise((resolve, reject) => {

    return new Promise((resolve, reject) => {
      this.apisrvc.get(rte).subscribe((res) => {
        this.metadata = res['data'];
        resolve(res['data'])
        // return of(res['data']);
      })
    })

    // this.getDepartments()
    // })

    // 
  }
  getUsersLst(data) {
    const rte = 'task-manager/users/dsgns/dptrmnt';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {
        // console.log(res, "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")
        resolve(res['data'])
        // return of(res['data']);
      })
    })

  }
  getDesignationsLst(dprt_id) {
    const rte = 'task-manager/task/designations/' + dprt_id;
    return new Promise((resolve, reject) => {
      this.apisrvc.get(rte).subscribe((res) => {
        // console.log(res, "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk")
        resolve(res['data'])
        // return of(res['data']);
      })
    })

  }
  updatetask(data) {
    const rte = 'task-manager/update/taskdetails';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }

  reopenTask(taskId: number) {
    const rte = 'task-manager/task/reopen';
    return new Promise((resolve, reject) => {
      this.apisrvc.post({ tckt_id: taskId }, rte).subscribe(
        (res) => {
          resolve(res['data']);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  completeTask(taskId: number) {
    const rte = 'task-manager/task/complete';
    return new Promise((resolve, reject) => {
      this.apisrvc.post({ tckt_id: taskId }, rte).subscribe(
        (res) => {
          resolve(res['data']);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  closeTask(taskId: number) {
    const rte = 'task-manager/task/close';
    return new Promise((resolve, reject) => {
      this.apisrvc.post({ tckt_id: taskId }, rte).subscribe(
        (res) => {
          resolve(res['data']);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  sendWhatsAppUpdate(taskId) {
    const rte = `task-manager/send/whatsapp/update/notification/${taskId}`;
    return new Promise((resolve, reject) => {
      this.apisrvc.get(rte).subscribe(
        (res) => {
          resolve(res['data']);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
  forwardmultipletasks(data) {
    const rte = 'task-manager/forward/multiple/tasks';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }
  asgntasktomultpleOfcrs(data) {
    const rte = 'task-manager/task/assign/multiple/officers';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }
  farwardtask(data) {
    const rte = 'task-manager/forward/task';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }

  // Legacy methods for backward compatibility
  getDepartments() {
    const rte = 'task-manager/hirachy/based/departments/0';
    return new Promise((resolve, reject) => {
      this.apisrvc.get(rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }
  getMltDsgnDprtUsrs(data) {
    const rte = 'task-manager/department/desginations/users';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })

  }
  getMltpleDesignationsLst(data) {
    const rte = 'task-manager/department/based/multiple/desginations';
    return new Promise((resolve, reject) => {
      this.apisrvc.post(data, rte).subscribe((res) => {

        resolve(res['data'])
        // return of(res['data']);
      })
    })
  }

  getTaskStatuses(): string[] {
    return this.metadata.statuses.map(s => s.sts_nm);
  }

  getPriorities(): string[] {
    return this.metadata.priorities.map(p => p.prty_nm);
  }

  getCategories(): string[] {
    return this.metadata.categories.map(c => c.ctgry_nm);
  }

  insertUsrGrvncs(postdata) {
    return new Promise((resolve, reject) => {
      let hndlr = 'rprsnt_tckt'
      let rte = 'task-manager/User/grivence/form/' + hndlr
      this.apisrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  updteRprsntnTcktCtrl(postdata) {
    return new Promise((resolve, reject) => {
      let rte = 'task-manager/update/grivence/form'
      this.apisrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getTcktCnts() {
    return new Promise((resolve, reject) => {
      let rte = 'task-manager/grvnce/cnts'
      this.apisrvc.get(rte).subscribe((res) => {
        resolve(res)

      })
    })
  }
  getInboxTcktCnts() {
    return new Promise((resolve, reject) => {
      let rte = 'task-manager/assigned/grvnce/cnts'
      this.apisrvc.get(rte).subscribe((res) => {
        resolve(res)

      })
    })
  }

  getTcktDtls(tckt_ctgry_id, sub_catgory_hndrl_tx = 'total') {
    return new Promise((resolve, reject) => {
      let rte = `task-manager/grvnce/tckt/dtls/${tckt_ctgry_id}/${sub_catgory_hndrl_tx}`
      this.apisrvc.get(rte).subscribe((res) => {
        resolve(res)

      })
    })
  }

  getGrvncTcktDtls() {
    return new Promise((resolve, reject) => {
      let rte = `task-manager/grvnce/grvnc/tckts`
      this.apisrvc.get(rte).subscribe((res) => {
        resolve(res)

      })
    })
  }
  getActivityGrvncTcktDtls() {
    return new Promise((resolve, reject) => {
      let rte = `task-manager/my-activities/grvnc/tckts`
      this.apisrvc.get(rte).subscribe((res) => {
        resolve(res)

      })
    })
  }

  onInsertUserTags(postdata) {
    const rte = 'task-manager/user/tags/add';
    return this.apisrvc.post(postdata, rte)

  }

  onSaveSideMenuUserTags(postdata) {
    const rte = 'task-manager/save/sidemenu/user/tags';
    return this.apisrvc.post(postdata, rte)
  }

  onInsertTicketTags(postData) {
    const rte = 'task-manager/user/tickets/tags';
    return this.apisrvc.post(postData, rte)
  }

  onRemoveuserTagbyIdId(tagId) {
    const rte = 'task-manager/user/tags/remove/' + tagId;
    return this.apisrvc.get(rte)

  }

  getUserAvailabletags() {
    return this.apisrvc.get('task-manager/user/available/tags');
  }

  getclientAvailabletags() {
    return this.apisrvc.get('task-manager/client/available/tags');
  }

  getusertagsbyticketid(tckt_id) {
    const rte = 'task-manager/user/tags/' + tckt_id;
    return this.apisrvc.get(rte)

  }

  onUpdateTicketTags(data: any) {
    return this.apisrvc.post(data, 'task-manager/update/task/tags');
  }

  updteTcktStatus(data): Observable<any> {
    return this._httpClient.put(this._baseURL + 'task-manager/ticket/status', { data }).pipe(
      catchError(() =>
        // Return false
        of(false)
      ),
      switchMap((response: any) => {
        if (response) {
          return of(response);
        } else {
          return of(false);
        }
      })
    );
  }

  getUsertagsByUserIdWitckTicketCounts() {
    return this.apisrvc.get('task-manager/user/available/tags/counts');
  }


  onGetDepartmentRepresentation(postdata) {
    return this.apisrvc.post(postdata, 'task-manager/department/representation');
  }
  onGetMadalGpRepresentation(postdata) {
    return this.apisrvc.post(postdata, 'task-manager/madal/gp/representation');
  }
  onGetApplicantsRepresenations(postdata) {
    return this.apisrvc.post(postdata, 'task-manager/applicants/representation');
  }
  onGetAllRepresentativesCategories(postdata) {
    return this.apisrvc.post(postdata, 'task-manager/category/representatives');
  }

  onGetAllRepresentativePriority(postdata) {
    return this.apisrvc.post(postdata, 'task-manager/priority/representatives');
  }

  onGetallStatuses() {
    return this.apisrvc.get('task-manager/representatives/status');
  }

  onRemoveAttachment(attachmentId) {
    return this.apisrvc.get('task-manager/remove/attachment/' + attachmentId);
  }


  onGetclientbasedSubcategories() {
    return this.apisrvc.get('task-manager/client/representation/subcategories');
  }


}
